import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle';
import React from 'react';
import styled from 'styled-components';

import { AtiraIcon } from '../../../components/AtiraIcon';
import { Flex } from '../../../components/Flex';
import { Text } from '../../../components/Text';
import { Breakpoints } from '../../../theme/Breakpoints';
import { Rounded } from '../../../theme/Rounded';
import { Shadow } from '../../../theme/Shadow';
import { Spacing } from '../../../theme/Spacing';

const WidgetWrapper = styled(Flex)`
  flex-direction: column;
  gap: ${Spacing.s};
  min-width: 100%;
  max-width: 100%;
  flex-grow: 1;

  @media (min-width: ${Breakpoints.TABLET}) {
    min-width: 40%;
    max-width: 49%;
  }
`;

const Widget = styled(Flex)`
  background-color: ${({ theme }) => theme.bgCanvas};
  border-radius: ${Rounded.lg};
  height: 100%;
  flex-grow: 1;
  max-height: 14rem;
  padding: 1rem;
  box-shadow: ${Shadow.SM};
  margin-bottom: ${Spacing.m};
  flex-direction: column;
  gap: ${Spacing.m};
`;

const Title = styled(Text)`
  font-weight: bold;
  padding: 0.2rem 0;
`;

const StyledSpan = styled.span`
  color: ${({ theme }) => theme.fgSecondary};
`;

type AdminStatsWidgetProps = {
  title: string;
  stats: { key: string; value: number }[];
};

export const AdminStatsWidget: React.FC<AdminStatsWidgetProps> = ({
  title,
  stats = [],
}) => {
  return (
    <WidgetWrapper>
      <Title fontSize="l">{title}</Title>

      <Widget>
        {stats.map((s) => (
          <Flex alignItems="center" gap="s">
            <AtiraIcon icon={faCircle} color="main" size="xs" />
            <Text color="main" wordBreak="break-word">
              {`${s.key} `}
              <StyledSpan>{s.value ?? 0}</StyledSpan>
            </Text>
          </Flex>
        ))}
      </Widget>
    </WidgetWrapper>
  );
};
